import { useQuery } from 'react-query';

import ActivityService from '../../../services/ActivityService';
import { ACTIVITY } from '../../constants/queryDefinition';
import PaymentsOnHoldSummaryModel from '../../models/PaymentOnHoldSummary';
import MergedPaymentsOnHoldSummaryModel from '../../models/MergedPaymentOnHoldSummary';

const activityService = ActivityService.get();

const usePaymentsOnHoldSummary = (etrPaymentsOnHold, options) => {
  const queryPaymentOnHoldSummary = async () => {
    const serviceResponse = await activityService.getPaymentsOnHoldSummary({
      filter: { id: 0 }
    });
    return serviceResponse;
  };

  const useQueryParams = {
    staleTime: ACTIVITY.GET_PAYMENT_ON_HOLD_SUMMARY.STALE_TIME,
    cacheTime: ACTIVITY.GET_PAYMENT_ON_HOLD_SUMMARY.STALE_TIME,
    enabled: true,
    retry: false
  };

  const response = useQuery(
    ACTIVITY.GET_PAYMENT_ON_HOLD_SUMMARY.KEY,
    queryPaymentOnHoldSummary,
    useQueryParams
  );

  if (options?.isMergedPaymentsOnHoldEnabled) {
    return new MergedPaymentsOnHoldSummaryModel(
      response?.data,
      etrPaymentsOnHold
    );
  }

  return new PaymentsOnHoldSummaryModel(response?.data);
};

export default usePaymentsOnHoldSummary;
